<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-content">
            <button
                class="modal-close is-large"
                style="z-index: 999;"
                aria-label="close"
                @click="$emit('close')"
            ></button>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// _modal.vue?36503d8a